import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Button, Snackbar, Alert, Paper, Container } from '@mui/material';
import { useAuth } from '../auth/Auth';

const ContractorSelector = () => {
  const [showChangeForm, setShowChangeForm] = useState(false);
  const [availableContractors, setAvailableContractors] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [contractorNames, setContractorNames] = useState({});
  const [defaultContractor, setDefaultContractor] = useState(null);
  const { user } = useAuth();

  const fetchContractorNames = async (contractors) => {
    try {
      const response = await axios.get(`https://bank2.daolog.net/contractor-names/${contractors.join(',')}`);
      const namesMap = response.data.reduce((acc, curr) => {
        acc[curr.id] = curr.name;
        return acc;
      }, {});
      setContractorNames(namesMap);
    } catch (error) {
      console.error('Error fetching contractor names:', error);
    }
  };

  const fetchUserConfig = async () => {
    try {
      const response = await axios.get(`https://bank2.daolog.net/user-config/${user.user_id}`);
      if (response.data?.contractors?.length) {
        setAvailableContractors(response.data.contractors);
        fetchContractorNames(response.data.contractors);
      }
      
      const configResponse = await axios.get(`https://bank2.daolog.net/user-configs`);
      const userConfig = configResponse.data.find(config => config.user_id === user.user_id);
      if (userConfig) {
        setDefaultContractor(userConfig.default_contractor_id);
      }
    } catch (error) {
      console.error('Error fetching user config:', error);
      setError('Помилка отримання даних');
    }
  };

  useEffect(() => {
    fetchUserConfig();
  }, []);

  const handleChangeEstablishment = async () => {
    setShowChangeForm(true);
    try {
      const response = await axios.get(`https://bank2.daolog.net/user-config/${user.user_id}`);
      if (response.data?.contractors?.length) {
        setAvailableContractors(response.data.contractors);
        fetchContractorNames(response.data.contractors);
      } else {
        setError('Помилка: дані закладів відсутні');
      }
    } catch (error) {
      setError('Помилка при отриманні даних закладів');
    }
  };

  const handleConfirm = async () => {
    if (!selectedContractor) return;
    
    try {
      await axios.post('https://bank2.daolog.net/set-default-contractor', {
        userId: user.user_id,
        contractorId: selectedContractor
      });
      
      setDefaultContractor(selectedContractor);
      setShowChangeForm(false);
      setSelectedContractor(null);
      setSuccess(true);
      fetchUserConfig();
    } catch (error) {
      console.error('Error updating contractor:', error);
      setError('Помилка при оновленні даних');
    }
  };

  const handleCancel = () => {
    setShowChangeForm(false);
    setSelectedContractor(null);
  };

  const handleCloseSnackbar = () => {
    setSuccess(false);
    setError(null);
  };

  return (
    <Container maxWidth="md" style={{ marginTop: "130px" }}>
      <Paper elevation={3} style={{ padding: '30px', borderRadius: '15px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" align="center" gutterBottom>
            <strong>Заклад за замовчуванням:</strong> {defaultContractor ? contractorNames[defaultContractor] : ''}
          </Typography>
          
          <Button 
            variant="contained" 
            onClick={handleChangeEstablishment}
            style={{ marginTop: '20px', marginBottom: '20px' }}
          >
            Змінити заклад
          </Button>

          {showChangeForm && (
            <div style={{ width: '100%', textAlign: 'center' }}>
              <Typography variant="h6" gutterBottom>
                Оберіть заклад:
              </Typography>
              <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
                {availableContractors.map((contractorId) => (
                  <Button
                    key={contractorId}
                    variant={selectedContractor === contractorId ? "contained" : "outlined"}
                    onClick={() => setSelectedContractor(contractorId)}
                    style={{ 
                      backgroundColor: selectedContractor === contractorId ? '#ffa500' : 'white'
                    }}
                  >
                    {contractorNames[contractorId] || contractorId}
                  </Button>
                ))}
              </div>
              <div style={{ marginTop: '20px' }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleConfirm}
                  style={{ marginRight: '10px' }}
                  disabled={!selectedContractor}
                >
                  Зберегти
                </Button>
                <Button 
                  variant="outlined" 
                  onClick={handleCancel}
                >
                  Скасувати
                </Button>
              </div>
            </div>
          )}
        </div>
      </Paper>
      
      <Snackbar open={success} autoHideDuration={3000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="success">
          Заклад успішно змінено!
        </Alert>
      </Snackbar>

      <Snackbar open={!!error} autoHideDuration={3000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ContractorSelector;